import React from 'react';
import FormNavBar from '../../components/common/wizard_navbar';
import WizardRotulosEditFormComponent from '../../components/MainPageComponent/wizard_rotulos_edit_form';


class WizardRotulosEditFormPage extends React.Component{
    render(){
        return (
            <div className="dashboard">
                <FormNavBar />
                <WizardRotulosEditFormComponent />
            </div>
        )
    }
}


export default WizardRotulosEditFormPage;